import React, { useState } from "react";
import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import classNames from "classnames";
import { Plus, ChevronDown, LogIn } from "react-feather";
import { Inertia } from "@inertiajs/inertia";

export function AgencyClientsSidebarDropdown({ closeMobileNavigation }) {
  let { url } = usePage();

  let organizations = usePage().props?.global_clients?.data || [];
  const favoriteIds =
    usePage().props?.auth?.user?.data?.meta?.favorite_organizations || [];

  const [isOpen, setIsOpen] = useState(url.startsWith("/agency/clients"));

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="group mb-2 flex">
        <InertiaLink
          className={classNames(
            "mr-1 flex-1 rounded-sm px-4 py-3 text-[18px] font-bold leading-[130%]",
            {
              "lg:group-hover:bg-black-dark":
                !url.startsWith("/agency/clients"),
              "bg-yellow text-black group-hover:bg-yellow lg:group-hover:bg-yellow":
                url.startsWith("/agency/clients"),
            },
          )}
          href={route("agency.clients")}
          onClick={closeMobileNavigation}
        >
          Clients
        </InertiaLink>

        <span
          className={classNames(
            "cursor-pointer rounded-sm p-3 lg:group-hover:bg-black",
            {
              "lg:group-hover:bg-black-dark":
                !url.startsWith("/agency/clients"),
              "bg-yellow text-black group-hover:bg-yellow lg:group-hover:bg-yellow":
                url.startsWith("/agency/clients"),
            },
          )}
          onClick={handleToggleDropdown}
        >
          <ChevronDown
            className={`transition-all ${isOpen ? "rotate-180" : ""}`}
          />
        </span>
      </div>

      {isOpen && organizations && (
        <>
          {organizations
            .filter((o) => !o.locked_at && favoriteIds.includes(o.id))
            .map((organization) => {
              const link = route("agency.clients.edit", organization.id);

              return (
                <button
                  key={organization.id}
                  className={
                    "rounded-sm px-4 py-2 text-left text-base leading-[137%] hover:bg-black-dark"
                  }
                  onClick={() =>
                    Inertia.put(route("agency.clients.view", organization.id))
                  }
                >
                  <LogIn size={18} className="-mt-1 inline" />{" "}
                  {organization.name}
                </button>
              );
            })}
        </>
      )}

      {isOpen && (
        <InertiaLink
          className="relative rounded-sm px-4 py-2 text-base leading-[137%] hover:bg-black"
          href={route("agency.clients.create")}
          onClick={closeMobileNavigation}
        >
          Add new client
          <Plus className="absolute right-2 top-1/2 -translate-y-1/2" />
        </InertiaLink>
      )}

      {isOpen && <span className="border-b border-[#535E63] px-4 py-1"></span>}
    </>
  );
}
